var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "26px",
    viewBox: "0 0 30 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.249942, 0.250000)",
    fill: "#3F3F3F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5000583,15.75 L18.0000583,15.75 L18.0000583,24.75 C18.0000583,25.1642136 18.3358447,25.5 18.7500583,25.5 L26.7500583,25.5 C27.1642718,25.5 27.5000583,25.1642136 27.5000583,24.75 L27.5000583,11.75 C27.5000583,11.3357864 27.1642718,11 26.7500583,11 C26.3358447,11 26.0000583,11.3357864 26.0000583,11.75 L26.0000583,24 L19.5000583,24 L19.5000583,15 C19.5000583,14.5857864 19.1642718,14.25 18.7500583,14.25 L10.7500583,14.25 C10.3358447,14.25 10.0000583,14.5857864 10.0000583,15 L10.0000583,24 L3.50005825,24 L3.50005825,11.75 C3.50005825,11.3357864 3.16427182,11 2.75005825,11 C2.33584469,11 2.00005825,11.3357864 2.00005825,11.75 L2.00005825,24.75 C2.00005825,25.1642136 2.33584469,25.5 2.75005825,25.5 L10.7500583,25.5 C11.1642718,25.5 11.5000583,25.1642136 11.5000583,24.75 L11.5000583,15.75 Z",
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3141296,11.3603001 C28.651189,11.6010568 29.1196016,11.5229881 29.3603584,11.1859286 C29.6011151,10.8488692 29.5230463,10.3804566 29.1859869,10.1396999 L15.1859869,0.139699897 C14.9252138,-0.0465666322 14.5749027,-0.0465666322 14.3141296,0.139699897 L0.314129609,10.1396999 C-0.022929831,10.3804566 -0.100998592,10.8488692 0.139758151,11.1859286 C0.380514894,11.5229881 0.84892746,11.6010568 1.1859869,11.3603001 L14.7500583,1.67167771 L28.3141296,11.3603001 Z",
    id: "Path-8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9badcba190a7f96461bcddb84b54baaa.svg";
export { ForwardRef as ReactComponent };